import React from 'react';
import Header from './header.js';

import {schedule, contact} from '../data/data';

import sber from '../img/sber.svg'

import map from '../img/map.png'

function Info() {
    const [isOpen, setIsOpen] = React.useState(null)

    const checkTime = () => {
        const now = new Date().toLocaleString('ru-RU', { timeZone: 'Europe/Astrakhan' })
        const hours = (now[12] + now[13]) - 0
        
        if (hours >= schedule.start && hours < schedule.end) {
            setIsOpen(true)
        } else {
            setIsOpen(false)
        }
    }

    React.useEffect(()=> {
        checkTime()
    },[])

    function getContact(){
        return contact.number + " (" + contact.name + ")"
    }

    const descriptionLines = [
        {
            headline: "Оплата:",
            text: "Наличная или перевод по номеру",
            additional: (
                <>
                    <div className='info__number'>
                        <img className='info__number__logo' src={sber}/>
                        <p className='info__number__digits'>{getContact()}</p>
                    </div>
                </>
            )
        },

        {
            headline: "Адрес:",
            text: "г. Астрахань, ул. Яблочкова 23/2",
        },

        {
            headline: "График работы:",
            text: "ПН-ВС "+ schedule.start + ":00 - " + schedule.end + ":00",
            additional: (
                    <p className={"info__status info__status__" + ( isOpen !== 404 ? (isOpen ? "open" : "closed") : "none")}>
                        { isOpen ? "Открыто" : "Закрыто"}
                    </p>
                )
        },
    ]

    return ( 
        <section className='info order__3 animloadWithSlide'>
            <Header/>
            <section className='info__place tile'>
                <img className='info__map' src={map}/>
                <section className='info__description'>
                    {
                        descriptionLines.map((line, lineIndex) => {
                            return (
                                <div className='info__line' key={"line" + lineIndex}>
                                    <h3 className='info__headline'>
                                        {line.headline}
                                    </h3>

                                    <p className='info__line__text'>
                                        {line.text} 
                                    </p>

                                    {line.additional}
                                </div>
                            )
                        })
                    }
                </section>
            </section>
            
            <section className='info__contact tile'>
                <h3 className='info__contact__headline'>
                    Вы можете сделать заказ <span className='info__contact__add'>заранее</span> или <span className='info__contact__add'>заказать доставку</span>.
                </h3>
            </section>
        </section>
    );
}

export default Info;